import styled from 'styled-components';
import { ICON_SIZE } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { Skeleton } from 'newcomponents/UI/Skeleton';

const iconSize = isMobile() ? ICON_SIZE.MOBILE_24 : ICON_SIZE.DESKTOP_32;

const MenuItem = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BottomNavigationSkeleton = (): JSX.Element => {
  return (
    <>
      {Array.from({ length: 5 }, (v, i) => i).map(key => (
        <MenuItem key={key}>
          <Skeleton.Avatar size={iconSize} active />
          <Skeleton
            title={{ style: { height: 9, width: '60%', margin: '5px auto' } }}
            paragraph={false}
            active
          />
        </MenuItem>
      ))}
    </>
  );
};
